import { Box } from "@mui/material"
import { CreateActivityForm } from "./types"
import { useTranslation } from "react-i18next"
import { AgentSteps } from "./components/agentSteps"
import { useContextState } from "../../../../../../../../hooks/theme"
import { useState } from "react"
import { StepsRef } from "./components/interface"
import { useRefs } from "../../../../../../../../hooks/useReactHookModified"
import { stepsArray } from "./constants/arraySteps"
import { useStyles } from "./styles"
import { useInput } from "./hooks/useInput"
import { useBody } from "./hooks/body"


export const CreateActivity = ({ goBack }: CreateActivityForm) => {
    const { t } = useTranslation()
    const styles= useStyles()
    const { colors } = useContextState()
    const ref = useRefs<StepsRef>()
    const { filter, openField:typeActivityOpen, inputActivityCheck, setInputActivity, inputDestination, inputActivity, inputFilter, inputFilterUnity, formatFilter, filterUnity, formatFilterUnity } = useInput()
    const { destinatioCreated, editActivityDestination, localRegister, setLocalRegister, companies, tableUsers, isPartner, handleRowClickUnity, snackbar, closeSnackbar, handleSubmitActivities, config, openField, disabled, setUsersSelectedInActivity, usersSelectedInActivity, allUsers, disabledUsers, idOwnUser, setIdOwnUser, assignActivities, setUnityToDestination, tableUserActivity, getUsersList, loading, totalPages, getUsersDataSteps2, tableUnits, activities, deleteActivity, editActivity, handleActivities, open, setOpen, setUsersSelected, usersSelected, destination, setDestination, destinationFinal, setDestinationFinal } = useBody(filter,formatFilter,formatFilterUnity, filterUnity)
    const [steps, setSteps] = useState<number | undefined>(isPartner ? 1:0)

    const handleSteps = (step: number) => {
        const currentStep = (steps ?? 0) + step

        if (currentStep === 1 ) {
            getUsersDataSteps2()
        }

        setSteps((prev) => (prev ?? 0) + step)
      }


    return (
        <Box sx={styles.main}>
            
            <AgentSteps
                stepsArray={stepsArray}
                isParnert={isPartner}
                color={colors}
                /* ref={(element) => { ref.addRef({ element, name: 'step' }) }} */
                goBack={()=>{}/* goBackToList */}
                handleSteps={handleSteps}
                activeStep={steps}
                steps={steps}
                closeSnackbar={closeSnackbar}
                snackbar={snackbar}
                handleSubmitActivities={handleSubmitActivities}
                step1={{
                    t,
                    table: tableUsers,
                    openField:openField,
                    config:config,
                    filter:filter,
                    inputFilter: inputFilter,
                    getUsersList,
                    loading,
                    setUsersSelected,
                    usersSelected,
                    idOwnUser,
                    setIdOwnUser,
                    disable: disabled.step1
                }}
                step2={{
                    t,
                    table: tableUserActivity,
                    inputActivity: inputActivity,
                    open: open,
                    setOpen: setOpen,
                    inputActivityCheck: inputActivityCheck,
                    activities:activities,
                    handleActivities,
                    deleteActivity,
                    editActivity,
                    inputFilterUnity,
                    tableUnits,
                    filterUnity,
                    loading,
                    totalPages,
                    destination,
                    setDestination,
                    destinationFinal,
                    setDestinationFinal,
                    setUnityToDestination,
                    inputDestination,
                    allUsers,
                    assignActivities,
                    disabledUsers,
                    setUsersSelectedInActivity,
                    usersSelectedInActivity,
                    disable:disabled.step2,
                    handleSteps,
                    handleRowClickUnity,
                    setInputActivity,
                    typeActivityOpen,
                    companies,
                    editActivityDestination,
                    localRegister,
                    setLocalRegister,
                    destinatioCreated
                }}
            />
        </Box>
    )
}